module.exports = __webpack_public_path__ + "img/icon_search.04bf9373.png";